import styled from 'styled-components';
import { BoxWithBorderStyled } from '~/styles';
export const ToolRoomItemStyled = styled(BoxWithBorderStyled).attrs({
  py: { sm: '450' },
  px: { sm: '300' },
  flexGrow: { sm: '1' },
  borderBottomColor: 'grey.300',
})`
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue['100']};
    cursor: pointer;
  }
`;
